import { useSelector } from "react-redux";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { selectDesignationsListItems } from "../../../../../../redux/designations/selector";
import { designations } from "../../../../../../redux/designations/action";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table-manager/v1.1/table";

const ManagementDesignations = () => {
const dispatch = useAppDispatch()
const result = useSelector(selectCurrent)
const { header, footer, currency } = result
const [pageData, setPageData] = useState(1)
const itemsData = useSelector(selectDesignationsListItems)

    const [pageSize, setPageSize] = useState(10); 
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name',searchField: 'Name', sortable: true, filter: true, filterType: 'text'},
          { field: 'Remarks', headerName: 'Remarks'  },
           { field: 'CreatedOnUtc', headerName: 'Created On' },
            { field: 'ModifiedOnUtc', headerName: 'Modified On' },
      
        ]);
      }

      const fetchdesignation = () => {
        dispatch(designations.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/hrms/designations/list`,entity:'designations',
          jsonData: {
            "PageNumber": pageData,
            "PageSize": pageSize,
            "SortField": "Id",
            "SortOrder": "desc",
              
          }
        }))
      }
    
	useEffect(() => {
        createColumnDefs()
        fetchdesignation()
	}, [pageData,pageSize])

  const handleReloadData = () => {
    fetchdesignation()   
  }
  const additionButtons: any = [
    
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } 

    dispatch(designations.list({
      url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/hrms/designations/list`,
      entity:'designations',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
   
    }))
  }

  return (
    <>
      {itemsData?.isLoading ?
        <PageLoader /> :
        <Table 
        checkboxConfig={{
          allowMultiSelect: true,
          defaultSelectedIds: [],
          isDisabled: false,
          keyColumn: 'Id',
      }}
        columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
        additionButtons={additionButtons} enableFilter={true} onSearch={handleSearch} paginationData={itemsData?.result?.pagination} headingName="Designations" />
      }
    </>
  );
};

export default ManagementDesignations;


